// types
import type { GridRowParams } from '@mui/x-data-grid-pro';

/**
 * The class list for one grid row: the zebra stripe every row gets, plus one class per status flag
 * the row carries.
 *
 * Shared by both grids. Employee rows carry none of the flags, so they come out with the stripe
 * alone; the flags only ever appear on open-request groups.
 */
export const getRosterRowClassName = (
  params: GridRowParams & { indexRelativeToCurrentPage: number }
) => {
  const striped =
    params.indexRelativeToCurrentPage % 2 === 0
      ? 'stripedRow-even'
      : 'stripedRow-odd';

  const flagClasses = [
    [params.row?.isSendToFlex, 'send-to-flex-row'],
    [params.row?.isRosterMatch, 'roster-match-row'],
    [params.row?.isParked, 'parked-row'],
    [params.row?.isSelf, 'self-row'],
    [params.row?.isOpenForSelfMatch, 'open-for-self-match-row'],
    [params.row?.isSelfAndOpenForSelfMatch, 'self-and-open-for-self-match-row']
  ] as const;

  return [striped, ...flagClasses.filter(([on]) => on).map(([, name]) => name)]
    .join(' ')
    .trim();
};
